<template>
  <div class="app-container">
    <!-- Global Loading Overlay -->
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center loader-wrapper">
      <div>
        <img src="/img/preloader_img.png" class="w-50 d-block mx-auto" alt="" />
      </div>
    </div>

    <!-- Main Content -->
    <div class="mobile-viewport shadow-lg">
      <router-view v-slot="{ Component, route }">
        <transition :name="route.meta.transition || 'fade'">
          <div :key="route.name">
            <Component :is="Component"></Component>
          </div>
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isLoading() {
      return this.$store.getters.isLoading
    }
  }
}
</script>

<style>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.1/css/all.min.css');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '~bootstrap-icons/font/bootstrap-icons.css';

/* Global Styles */
body {
  font-family: 'Montserrat', sans-serif;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: smooth;
}

/* App Container & Mobile Viewport */
.app-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.mobile-viewport {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  background: #fff;
  flex: 1;
  display: flex;
  flex-direction: column;
  
  /* Safe area support for notched devices */
  padding-left: max(0px, env(safe-area-inset-left));
  padding-right: max(0px, env(safe-area-inset-right));
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .mobile-viewport {
    max-width: 100vw;
    margin: 0;
    padding-left: 0;
    padding-right: 0;
  }
}

/* Utility Classes */
.click-effect {
  cursor: pointer;
  transition: 0.1s all;
}

.click-effect:active {
  transform: scale(0.9);
}

.fade-effect {
  cursor: pointer;
  transition: 0.1s all;
}

.fade-effect:active {
  opacity: 0.3;
}

.disabled-component {
  pointer-events: none;
  cursor: none;
}

/* Loading Overlay */
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: #ffffff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-wrapper img {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-left-leave-active,
.slide-left-enter-active {
  transition: 1s;
}

.slide-left-enter {
  transform: translate(100%, 0);
}

.slide-left-leave-to {
  transform: translate(-100%, 0);
}

.slide-right-leave-active,
.slide-right-enter-active {
  transition: 1s;
}

.slide-right-enter {
  transform: translate(-100%, 0);
}

.slide-right-leave-to {
  transform: translate(100%, 0);
}

/* Accessibility */
[v-cloak] {
  display: none !important;
}
</style>
